import React, { useState } from "react";
import LockerCard from "./LockerCard";
import LockerDetailsModal from "./LockerDetailsModal";

/**
 * Helper to generate alphabetical label from index (e.g. 0 -> A, 25 -> Z)
 */
const getAlphabetLabel = (index) => {
  let label = "";
  let temp = index;
  while (temp >= 0) {
    label = String.fromCharCode((temp % 26) + 65) + label;
    temp = Math.floor(temp / 26) - 1;
  }
  return label;
};

function ContainerOverviewGrid({
  rows,
  columns,
  rowNamingFormat = "A,B,C..",
  colNamingFormat = "1,2,3..",
  lockers,
  disabledLockers = [],
  selectedHub,
  selectedHubName,
}) {
  const isRowAlphabet = rowNamingFormat.includes("A");
  const isColAlphabet = colNamingFormat.includes("A");

  const rowLabels = Array.from({ length: rows }, (_, rIndex) =>
    isRowAlphabet ? getAlphabetLabel(rIndex) : `${rIndex + 1}`,
  );

  const colLabels = Array.from({ length: columns }, (_, cIndex) =>
    isColAlphabet ? getAlphabetLabel(cIndex) : `${cIndex + 1}`,
  );

  const [selectedLocker, setSelectedLocker] = useState(null);
  const [popupPosition, setPopupPosition] = useState(null);

  return (
    <div className="bg-[#DFDFDF] p-2.5 max-h-[calc(100vh-280px)] overflow-y-auto hide-scrollbar">
      <div
        className="grid gap-2.5"
        style={{
          gridTemplateColumns: `repeat(${columns}, minmax(50px, 1fr))`,
        }}
      >
        {rowLabels.flatMap((rowLabel) =>
          colLabels.map((colLabel) => {
            const lockerId = `${rowLabel}${colLabel}`;

            if (disabledLockers?.includes(lockerId)) {
              return (
                <div
                  key={lockerId}
                  className="
                      h-[110px]
                      border-2
                      border-dashed
                      border-dark-gray
                      bg-transparent
                    "
                />
              );
            }

            const locker = lockers?.find((l) => l.lockerId === lockerId) || {
              lockerId,
              status: 1,
            };

            console.log("locker", locker);

            return (
              <LockerCard
                key={lockerId}
                locker={locker}
                selectedHub={selectedHub}
                className={`relative ${
                  selectedLocker?.lockerId === locker.lockerId
                    ? "z-[45]"
                    : "z-0"
                } `}
                onClick={(e) => {
                  if (locker.status === 1) return;

                  const rect = e.currentTarget.getBoundingClientRect();

                  setSelectedLocker(locker);

                  const POPUP_WIDTH = 286;
                  const POPUP_HEIGHT = 172; // adjust to actual popup height
                  const GAP = 42;

                  let left = rect.right + 10;
                  let { top } = rect;

                  if (left + POPUP_WIDTH > window.innerWidth) {
                    left = rect.left - POPUP_WIDTH - GAP;
                  }

                  if (top + POPUP_HEIGHT > window.innerHeight) {
                    top = window.innerHeight - POPUP_HEIGHT - GAP;
                  }

                  setPopupPosition({
                    left,
                    top,
                  });
                }}
              />
            );
          }),
        )}
        {selectedLocker && (
          <div
            className="
      absolute
      inset-0
      bg-black/30
      z-40
    "
            onClick={() => {
              setSelectedLocker(null);
              setPopupPosition(null);
            }}
          />
        )}
        {selectedLocker && popupPosition && (
          <LockerDetailsModal
            selectedHub={selectedHub}
            selectedHubName={selectedHubName}
            locker={selectedLocker}
            position={popupPosition}
            onClose={() => {
              setSelectedLocker(null);
              setPopupPosition(null);
            }}
          />
        )}
      </div>
    </div>
  );
}

export default ContainerOverviewGrid;
